import { Location, NavigateFunction } from 'react-router-dom';

export const normalizeLocationHash = (hash: string): string => {
  if (!hash || hash === '#') {
    return '';
  }
  return hash.startsWith('#') ? hash : `#${hash}`;
};

export const getHashForTabIndex = (
  tabIndex: number,
  hashTabMap: Record<string, number>,
): string => {
  const entry = Object.entries(hashTabMap).find(
    ([, index]) => index === tabIndex,
  );
  return entry?.[0] ?? '';
};

export const syncHashForTab = (
  tabIndex: number,
  hashTabMap: Record<string, number>,
  location: Location,
  navigate: NavigateFunction,
) => {
  const targetHash = getHashForTabIndex(tabIndex, hashTabMap);
  const currentHash = normalizeLocationHash(location.hash);

  if (currentHash === targetHash) {
    return;
  }

  if (!targetHash) {
    navigate(`${location.pathname}${location.search}`, { replace: true });
    return;
  }

  navigate(
    {
      pathname: location.pathname,
      search: location.search,
      hash: targetHash.slice(1),
    },
    { replace: true },
  );
};
